<template>
  <div class="home">
    <div class="top">
      <div class="left-box">
        <div class="top-title" @click="pushDo">Benchmark</div>
        <div class="setting-box" id="setting-bg-box" ref="setting-ref">
          <el-dropdown id="zsdropdown" trigger="click" :hide-on-click="false">
            <el-button class="setting-btn"
              >Metrics-Setting<i
                class="el-icon-caret-bottom el-icon-caret-top"
              ></i
            ></el-button>
            <template #dropdown>
              <el-dropdown-menu class="dropdown-menu" id="dropdown-menu">
                <el-dropdown-item
                  v-for="(item, index) in setingItemList"
                  class="dropdown-item"
                  :command="index"
                  :key="index"
                  :disabled="false"
                  >{{ item.title }}
                  <el-switch
                    class="vs-switch"
                    active-color="#0050B3"
                    inactive-color="#E8E8E8"
                    @change="setingSwitchChange(item)"
                    v-model="item.isSwitch"
                  ></el-switch
                ></el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <div class="num-box">
        <div class="case-num row-head-w">{{ dataList.length }} Test case</div>
      </div>
      <div class="version-content">
        <div class="version-bg">
          <div class="tool-box">
            <div class="tool-title-box">
              <div class="tool-title">Tool</div>
              <Version
                class="version-w"
                :list="toolList"
                :versionIndex="0"
                :version="leftTool.tool"
                @selectIrqDo="selectIrqDo"
              >
              </Version>
            </div>
            <div class="tool-title-box">
              <div class="tool-title">Version</div>
              <Version
                class="version-w"
                :list="leftVersionList"
                :versionIndex="1"
                :version="leftTool.release"
                @selectIrqDo="selectIrqDo"
              >
              </Version>
            </div>
            <div class="vs-box">
              <div class="vs-title" :style="{ color: vsStyle.color }">VS</div>
              <el-switch
                class="vs-switch"
                v-model="isSwitch"
                active-color="#0050B3"
                inactive-color="#E8E8E8"
                @change="switchChange"
              ></el-switch>
            </div>
            <div class="tool-title-box" v-show="isSwitch">
              <div class="tool-title">Tool</div>
              <Version
                class="version-w"
                :backgroundColor="versionBackColor"
                :list="toolList"
                :version="rightTool.tool"
                :versionIndex="2"
                @selectIrqDo="selectIrqDo"
              ></Version>
            </div>
            <div class="tool-title-box" v-show="isSwitch">
              <div class="tool-title">Version</div>
              <Version
                class="version-w"
                :backgroundColor="versionBackColor"
                :list="rightVersionList"
                :version="rightTool.release"
                :versionIndex="3"
                @selectIrqDo="selectIrqDo"
              ></Version>
            </div>
          </div>
        </div>

        <div class="header-title-box">
          <HomeHeaderTitle
            class="header-title"
            v-for="(model, index) in headerTitleList"
            :model="model"
            :key="index"
            :isShowThree="isSwitch"
            :index="index"
            @clickSort="clickSort"
          ></HomeHeaderTitle>
        </div>
      </div>
    </div>

    <div class="table-bg">
      <NewMarkLineItem
        v-for="(item, index) in dataList"
        :item="item"
        :isShowThree="isSwitch"
        :key="index"
      >
      </NewMarkLineItem>
    </div>
  </div>
</template>
<script>
import Version from "@/components/Version.vue";
import HomeHeaderTitle from "@/components/HomeHeaderTitle.vue";
import NewMarkLineItem from "@/components/NewMarkLineItem.vue";
import { getBenchMarks } from "@/request/api";
import { setStoreMarkData, getStoreMarkData } from "@/utils/Setitem";
import Sortable from "sortablejs";
export default {
  name: "home",
  data() {
    return {
      isShow: false,
      isSwitch: false,
      vsStyle: {
        color: "#0050B3",
      },
      testValue: false,
      curSelectTitle: "",
      leftTool: {},
      rightTool: {},
      toolList: [],
      versionList: [],
      leftVersionList: [],
      rightVersionList: [],
      allMarkList: [],
      dataList: [],
      versionBackColor: "#f6f6f6",
      headerTitleList: [],
      setingItemList: [],
      orderItemList: [],
      sortable: null,
      moveNumList: [],
    };
  },
  methods: {
    setingSwitchChange() {
      if (this.orderItemList.length == 0) {
        this.orderItemList = this.setingItemList;
      } else {
        for (const model of this.orderItemList) {
          const arr = this.setingItemList.filter((setItem) => {
            return setItem?.title == model?.title
          })
          if (arr.length > 0) {
            model.isSwitch = arr[0].isSwitch
          }
        }
      }

      this.headerTitleList = [];
      for (const model of this.orderItemList) {
        if (model?.isSwitch) {
          this.headerTitleList.push(model);
        }
      }
      this.getListData();
    },
    selectIrqDo(model) {
      console.log("model = ", model);
      const versionIndex = model.versionIndex;
      if (versionIndex == 0) {
        this.leftTool.tool = model.item.originTitle;
        this.getLeftVersionList();
        this.leftTool.release = this.leftVersionList[0].originTitle;
      } else if (versionIndex == 1) {
        this.leftTool.release = model.item.originTitle;
      } else if (versionIndex == 2) {
        this.rightTool.tool = model.item.originTitle;
        this.getRightVersionList();
        this.rightTool.release = this.rightVersionList[0].originTitle;
      } else if (versionIndex == 3) {
        this.rightTool.release = model.item.originTitle;
      }
      this.getSelectMarks();
    },

    getLeftVersionList() {
      this.leftVersionList = [];
      for (const version of this.versionList) {
        if (version.tool == this.leftTool.tool) {
          this.leftVersionList.push(version);
        }
      }
    },

    getRightVersionList() {
      this.rightVersionList = [];
      for (const version of this.versionList) {
        if (version.tool == this.rightTool.tool) {
          this.rightVersionList.push(version);
        }
      }
    },

    getHeaderList(tool, release, changeSwitch, goTo) {
      if (!goTo) {
        return;
      }
      for (const index in this.allMarkList) {
        const markItem = this.allMarkList[index];
        if (markItem.tool == tool && markItem.release == release) {
          for (const mapItem of markItem.resultsMap) {
            const itemList = [
              {
                selectUp: false,
                selectDown: false,
              },
              {
                selectUp: false,
                selectDown: false,
              },
              {
                selectUp: false,
                selectDown: false,
              },
            ];
            const title = mapItem[0];
            const item = {
              title: title,
              itemList: itemList,
              isSwitch: true,
            };

            if (changeSwitch) {
              const isHave = this.headerTitleList.some((m) => {
                return m.title == title;
              });
              if (!isHave) {
                this.headerTitleList.push(item);
              }
            } else {
              this.headerTitleList.push(item);
            }
          }
          break;
        }
      }
    },

    getSelectMarks() {
      this.dataList = [];
      this.headerTitleList = [];
      this.orderItemList = [];
      this.setingItemList = [];
      let leftDataList = [];
      let rightDataList = [];

      this.getHeaderList(
        this.leftTool.tool,
        this.leftTool.release,
        false,
        true
      );
      this.getHeaderList(
        this.rightTool.tool,
        this.rightTool.release,
        this.isSwitch,
        this.isSwitch
      );

      const _this = this;
      this.orderItemList = JSON.parse(JSON.stringify(this.headerTitleList));
      this.$nextTick(() => {
        _this.setingItemList = JSON.parse(JSON.stringify(_this.headerTitleList));
      })

      for (const item of this.allMarkList) {
        if (
          item.tool == this.leftTool.tool &&
          item.release == this.leftTool.release
        ) {
          const itemModel = this.getHeadersMarks(item, false, false);
          leftDataList.push(itemModel);
        }
        if (this.isSwitch) {
          if (
            item.tool == this.rightTool.tool &&
            item.release == this.rightTool.release
          ) {
            const itemModel = this.getHeadersMarks(item, false, this.isSwitch);
            rightDataList.push(itemModel);
          }
        }
      }

      this.dataList = leftDataList;
      if (leftDataList.length > 0) {
        if (rightDataList.length > 0) {
          rightDataList.forEach((rightM) => {
            const isHave = leftDataList.some((m) => {
              return m.title == rightM.title;
            });
            if (isHave) {
              for (const dataM of this.dataList) {
                if (dataM.title == rightM.title) {
                  for (const m of dataM.modelList) {
                    rightM.modelList.forEach((rM) => {
                      if (m.title == rM.title) {
                        m.num2 = rM.num2;
                      }
                    });
                  }
                }
              }
            } else {
              this.dataList.push(rightM);
            }
          });
        }
      } else {
        this.dataList = rightDataList;
      }
      console.log(this.dataList)
      this.storeData();
      // this.initSortable();
    },

    getHeadersMarks(item, isFirst, changeSwitch) {
      const resultsMap = item.resultsMap;
      const testCase = item.testcase;
      const modelList = [];
      for (const headerItem of this.headerTitleList) {
        const headerTitle = headerItem.title;
        let contentValue = "";
        for (const map of resultsMap) {
          const keyStr = map[0];
          if (headerTitle == keyStr) {
            contentValue = map[1];
            break;
          }
        }
        let num1 = "";
        let num2 = "";
        if (changeSwitch) {
          num2 = contentValue;
        } else {
          num1 = contentValue;
          if (isFirst) {
            num2 = contentValue;
          }
        }
        const itemM = {
          num1: num1,
          num2: num2,
          comp: "-",
          title: headerTitle,
        };
        modelList.push(itemM);
      }
      const dataModel = {
        title: testCase,
        modelList: modelList,
      };

      return dataModel;
    },

    getListData() {
      console.log("getListData =", this.dataList)
      for (const item of this.dataList) {
        if (item?.modelList?.length > 0) {
          for (const model of item.modelList) {
            const isHave = this.headerTitleList.some((headerItem) => {
              return headerItem?.title == model?.title
            })
            model.isHidden = !isHave
          }
        }
      }
      this.storeData();
    },
    getSortData(newIndex, oldIndex) {
      for (const item of this.dataList) {
        const modelList = item.modelList;
        const currRow = modelList.splice(oldIndex, 1)[0];
        modelList.splice(newIndex, 0, currRow);
      }
      this.storeData()
    },
    pushDo() {
      this.$router.push({ name: "Home" });
    },
    storeData() {
      const storeData = {
        left: {
          tool: this.leftTool.tool,
          release: this.leftTool.release,
        },
        right: {
          tool: this.rightTool.tool,
          release: this.rightTool.release,
        },
        isSwitch: this.isSwitch,
        data: this.dataList,
        headerTitleList: this.headerTitleList,
        setingItemList: this.setingItemList,
        orderItemList: this.orderItemList
      };
      setStoreMarkData(storeData);
    },
    switchChange() {
      this.vsStyle.color = this.isSwitch ? "#0050B3" : "#B8B8B8";
      this.getSelectMarks();
    },
    getItemValue(value, isTimeValue) {
      let h, min, sec, sum;
      if (isTimeValue) {
        if (value.includes("h")) {
          h = value.split("h")[0];
          const timeStr = value.split("h")[1];
          if (timeStr.includes("m")) {
            min = timeStr.split("m")[0];
            sec = timeStr.split("m")[1];
          }
          sum = h * 3600 + min * 60 + parseFloat(sec);
        } else if (value.includes("m")) {
          min = value.split("m")[0];
          sec = value.split("m")[1];
          sum = min * 60 + parseFloat(sec);
        } else if (value.includes("s")) {
          sum = parseFloat(value);
        } else {
          sum = parseFloat(value);
        }
      } else {
        sum = parseFloat(value);
      }
      return sum;
    },
    clickSort(modelItem) {
      console.log("modelItem = ", modelItem)
      const headerM = this.headerTitleList[modelItem.titleIndex];
      let isTimeValue = false;
      if (headerM.title.includes("Time") || headerM.title.includes("time")) {
        isTimeValue = true;
      }
      const arr = this.orderItemList.filter((setItem) => {
        return setItem.title == headerM.title
      })
      const valueIndex = this.orderItemList.indexOf(arr[0])
      for (const index in this.headerTitleList) {
        const headerItem = this.headerTitleList[index];
        for (const itemIndex in headerItem.itemList) {
          var iconItem = headerItem.itemList[itemIndex];
          iconItem.selectUp = false;
          iconItem.selectDown = false;

          if (
            index == modelItem.titleIndex &&
            itemIndex == modelItem.iconIndex
          ) {
            if (modelItem.isUp) {
              iconItem.selectUp = true;
            } else {
              iconItem.selectDown = true;
            }
          }
        }
      }

      if (modelItem.isUp) {
        if (modelItem.iconIndex == 0) {
          this.dataList.sort(
            (model1, model2) =>
              this.getItemValue(
                model1.modelList[valueIndex].num1,
                isTimeValue
              ) -
              this.getItemValue(
                model2.modelList[valueIndex].num1,
                isTimeValue
              )
          );
        } else if (modelItem.iconIndex == 1) {
          this.dataList.sort(
            (model1, model2) =>
              this.getItemValue(
                model1.modelList[valueIndex].num2,
                isTimeValue
              ) -
              this.getItemValue(
                model2.modelList[valueIndex].num2,
                isTimeValue
              )
          );
        } else {
          this.dataList.sort(
            (model1, model2) =>
              this.getItemValue(
                model1.modelList[valueIndex].comp,
                isTimeValue
              ) -
              this.getItemValue(
                model2.modelList[valueIndex].comp,
                isTimeValue
              )
          );
        }
      } else {
        if (modelItem.iconIndex == 0) {
          this.dataList.sort(
            (model1, model2) =>
              this.getItemValue(
                model2.modelList[valueIndex].num1,
                isTimeValue
              ) -
              this.getItemValue(
                model1.modelList[valueIndex].num1,
                isTimeValue
              )
          );
        } else if (modelItem.iconIndex == 1) {
          this.dataList.sort(
            (model1, model2) =>
              this.getItemValue(
                model2.modelList[valueIndex].num2,
                isTimeValue
              ) -
              this.getItemValue(
                model1.modelList[valueIndex].num2,
                isTimeValue
              )
          );
        } else {
          this.dataList.sort(
            (model1, model2) =>
              this.getItemValue(
                model2.modelList[valueIndex].comp,
                isTimeValue
              ) -
              this.getItemValue(
                model1.modelList[valueIndex].comp,
                isTimeValue
              )
          );
        }
      }
      this.storeData();
    },
    initSortable() {
      if (this.sortable) {
        this.sortable.destroy();
      }
      const _this = this
      const el = document.querySelector(".el-dropdown-menu.dropdown-menu");
      this.sortable = Sortable.create(el, {
        group: "dropdown-menu",
        sort: true,
        animation: 100,
        store: null,
        delay: 0,
        onEnd: ({ newIndex, oldIndex }) => {
          if (newIndex == oldIndex) {
            return
          }
          const moveItem = { newIndex: newIndex, oldIndex: oldIndex };
          this.moveNumList.push(moveItem);
          const testArr = JSON.parse(JSON.stringify(_this.orderItemList));
          const currRow = testArr.splice(oldIndex, 1)[0];
          testArr.splice(newIndex, 0, currRow);
          _this.orderItemList = testArr;
          _this.headerTitleList = [];
          for (const model of _this.orderItemList) {
            if (model?.isSwitch) {
              _this.headerTitleList.push(model);
            }
          }
          _this.getSortData(newIndex, oldIndex);
        },
      });
    },
  },

  computed: {},
  async created() {
    var model = {};
    var allMarks = await getBenchMarks(model);
    this.allMarkList = allMarks;
    console.log(allMarks);

    const toolOriginList = [];
    const versionOriginList = [];
    for (const item of allMarks) {
      if (item.tool && !toolOriginList.includes(item.tool)) {
        var title1 = item.tool;
        if (item.tool.includes("/")) {
          title1 = item.tool.split("/").pop();
        }

        const toolItem = {
          originTitle: item.tool,
          title: title1,
        };
        toolOriginList.push(item.tool);
        this.toolList.push(toolItem);
      }
      if (item.release && !versionOriginList.includes(item.release)) {
        var title2 = item.release;
        if (item.release.includes("/")) {
          const lastTitle = item.release.split("/").pop();
          if (lastTitle.includes(":")) {
            title2 = lastTitle.split(":").pop();
          }
        }

        const versionItem = {
          originTitle: item.release,
          title: title2,
          tool: item.tool,
        };
        versionOriginList.push(item.release);
        this.versionList.push(versionItem);
      }
    }

    model = {
      tool: this.toolList[0].originTitle,
      release: this.versionList[0].originTitle,
    };

    const storeModel = getStoreMarkData();
    console.log(storeModel)
    if (storeModel) {
      model = {
        tool: storeModel.left.tool,
        release: storeModel.left.release,
      };
    }

    this.leftTool = JSON.parse(JSON.stringify(model));
    this.rightTool = JSON.parse(JSON.stringify(model));

    this.getLeftVersionList();
    this.getRightVersionList();

    if (storeModel) {
      this.headerTitleList = storeModel.headerTitleList;
      this.setingItemList = storeModel.orderItemList//setingItemList;
      this.orderItemList = storeModel.orderItemList;
      this.isSwitch = storeModel.isSwitch;
      this.dataList = storeModel.data;
    } else {
      const marksList = allMarks;
      const firstItem = marksList[0];
      for (const mapItem of firstItem.resultsMap) {
        const itemList = [
          {
            selectUp: false,
            selectDown: false,
          },
          {
            selectUp: false,
            selectDown: false,
          },
          {
            selectUp: false,
            selectDown: false,
          },
        ];
        const title = mapItem[0];
        const item = {
          title: title,
          itemList: itemList,
          isSwitch: true,
        };
        this.headerTitleList.push(item);
      }

      for (const item of marksList) {
        if (
          this.leftTool.tool == item.tool &&
          this.leftTool.release == item.release
        ) {
          const itemModel = this.getHeadersMarks(item, true, false);
          this.dataList.push(itemModel);
        }
      }

      this.setingItemList = JSON.parse(JSON.stringify(this.headerTitleList));
      this.orderItemList = this.setingItemList;
    }
    this.initSortable();
  },
  components: {
    Version,
    HomeHeaderTitle,
    NewMarkLineItem,
  },
};
</script>
<style lang='less' scoped>
.home {
}
.top {
  height: 240px;
  display: flex;
  flex-direction: row;
  background-color: #0050b3;
  position: relative;
  .left-box {
    background-color: #0050b3;
    margin-left: 56px;
    width: 200px;
    .setting-box {
      margin-top: 60px;
      .setting-btn {
        height: 50px;
      }
    }
    .top-title {
      color: #fff;
      font-weight: bold;
      font-size: 38px;
      margin-top: 38px;
      cursor: pointer;
    }
  }

  .num-box {
    height: 100%;
    position: relative;
    margin-left: 30px;
  }

  .case-num {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 150px;
  }

  .row-head-w {
    width: 150px;
    height: 50px;
    color: #707070;
    font-size: 14px;
    font-weight: 500;
    background-color: #fff;
    border-radius: 6px;
  }

  .version-content {
    display: flex;
    flex-direction: column;

    background-color: #0050b3;
    padding-right: 30px;

    .version-bg {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .tool-box {
      display: flex;
      flex-direction: row;
      background-color: #fff;
      height: 100px;
      width: 1170px;
      margin-left: 20px;
      border-radius: 6px;
      align-items: center;
      margin-top: 26px;

      .tool-title-box {
        display: flex;
        flex-direction: column;
        margin-left: 15px;
        .tool-title {
          color: #707070;
          font-size: 18px;
          font-weight: 500;
        }
        .version-w {
          margin-top: 8px;
        }
      }

      .vs-box {
        width: 50px;
        margin-left: 15px;

        .vs-title {
          color: #0050b3;
          font-size: 20px;
          font-weight: 900;
        }

        .vs-switch {
          width: 40px;
          height: 18px;
        }
      }
    }

    .header-title-box {
      display: flex;
      flex-direction: row;
      margin-top: 25px;

      .header-title {
        margin-left: 20px;
      }
    }
  }
}

.table-bg {
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
}

.left-box {
  width: 443px;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
}

.right-box {
  width: calc(100vw - 475px);
  background-color: #fff;
  display: flex;
  flex-direction: row;

  .markItem-1 {
    margin-left: 10px;
  }
}

.el-dropdown-menu__item {
  color: #565656 !important;
  .vs-switch {
    width: 40px;
    height: 18px;
  }
}
</style>